import React, { Component } from "react";
import { Link } from 'react-router-dom';

class Withdrawatm extends Component {
  render() {
    return (
      <div>
        <section className="breadcrumbs">
          <div className="container">
            <div className="row">
              <div className="col-sm-6 a-breadcrumbs" style={{color: '#ffffff'}}>
                <Link to="/home" className="a-breadcrumbs">หน้าแรก</Link>&nbsp;
                <i className="fa fa-angle-right" />&nbsp;<a href="withdrawatm" className="a-breadcrumbs">ขั้นตอนการกู้ฉุกเฉินและถอนเงิน ออมทรัพย์สหกรณ์ผ่านบัตร ATM ธนาคารกรุงศรี</a>
              </div>
            </div>
          </div>
        </section>
        <section className="page-section">
        <div className="container">
          <br/>
          <div className="row">
            <div className="col-md-9 col-sm-9 mb-sm-50">
              <div className="divider gray left mt-20 mb-25" />
              <img src="Img/WithDrawATM/Slide1.png" />
            </div>
          </div>
          <br/><br/>
          <div className="row">
            <div className="col-md-9 col-sm-9 mb-sm-50">
              <div className="divider gray left mt-20 mb-25" />
              <img src="Img/WithDrawATM/Slide2.png" />
            </div>
          </div>
          <br/><br/>
          <div className="row">
            <div className="col-md-12 mb-sm-50">
              <div className="divider gray left mt-20 mb-25" />
              <h4>วิธีกดเงินกู้ฉุกเฉิน</h4>
              <div className="embed-responsive embed-responsive-16by9" style={{maxWidth: '850px'}}>
                <iframe
                  className="embed-responsive-item"
                  src="https://www.youtube.com/embed/ay2U-l7izjg"
                  allowFullScreen
                  title="วิธีกดเงินกู้ฉุกเฉิน"
                  style={{width: '100%', height: '478px'}}
                />
              </div>
            </div>
          </div>
          <br/><br/>
        </div>
        </section>
      </div>
    );
  }
}

export default Withdrawatm;
